import React from 'react';

import PopUp from './PopUp';

const SuccessPopup = ({
    title,
    secondaryText,
    buttonText,
    buttonOnClick,
    cancelButtonOnClick,
    className,
    minHeight,
    minWidth,
}) => (
    <div className="component-Elements-PopUp-SuccessPopup">
        <style jsx>
            {`
                .component-Elements-PopUp-SuccessPopup .close {
                    cursor: pointer;
                }

                .component-Elements-PopUp-SuccessPopup .fgb-bubble-logo {
                    width: 120px;
                    height: 120px;
                    background-image: url(https://d207ibygpg2z1x.cloudfront.net/image/upload/v1519321352/icons/fgb-bubble-logo.webp);
                    background-position: 50%;
                    background-repeat: no-repeat;
                    background-size: contain;
                    margin: auto;
                }

                .component-Elements-PopUp-SuccessPopup .text-center {
                    background-color: white;
                    padding: 30px;
                }

                .component-Elements-PopUp-SuccessPopup .allContent {
                    font-style: normal;
                }

                .component-Elements-PopUp-SuccessPopup .title {
                    font-family: "Open sans", sans-serif;
                    font-weight: 200;
                    font-size: 30px;
                    margin-bottom: 20px;
                    color: #353535;
                }
                .component-Elements-PopUp-SuccessPopup .popupText {
                    font-family: "Open Sans", sans-serif;
                    font-size: 14px;
                    width: 200px;
                    margin-bottom: 30px;
                    color: #353535;
                }
                .component-Elements-PopUp-SuccessPopup
                    .component-Elements-PopUp
                    .text-center
                    .button-div {
                    width: 180px;
                    height: 40px;
                    margin: 20px auto 0;
                }
                .component-Elements-PopUp-SuccessPopup
                    .component-Elements-PopUp
                    .component-Input-Button {
                    margin: auto;
                }
                .component-Elements-PopUp-SuccessPopup
                    .component-Elements-PopUp
                    .component-Input-Button
                    input {
                    height: 35px;
                    font-size: 13px;
                }
            `}
        </style>
        <PopUp
            className={className}
            showPopUp
            absolutePosition
            showOverlay
            cancel={cancelButtonOnClick}
            showLogo={false}
            maxHeight="370px"
            maxWidth="360px"
            close={buttonOnClick}
            buttonText={buttonText}
            minHeight={minHeight}
            minWidth={minWidth}
            hideCloseButton
            clickOutside
        >
            <div className="title">{title}</div>
            <div className="popupText">{secondaryText}</div>
        </PopUp>
    </div>
);

SuccessPopup.displayName = 'SuccessPopup';

export default SuccessPopup;
